export default __webpack_public_path__ + "static/media/bissell.24ba1716.svg";